import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SidebarViewIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Eye / View icon */}
      <path
        d="M2 12C4 8 7.5 5 12 5s8 3 10 7c-2 4-5.5 7-10 7s-8-3-10-7z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
      {/* Pupil */}
      <circle cx="12" cy="12" r="3" stroke={color} strokeWidth={strokeWidth} fill="none" />
      {/* Inner dot */}
      <circle cx="12" cy="12" r="1" fill={color} />
    </BaseIcon>
  ),
);

SidebarViewIcon.displayName = 'SidebarViewIcon';
